import type { PurchaseOrder } from "@shared/types";
import { differenceInMinutes, max, parseISO } from "date-fns";

export const computeOrderAge = (order: PurchaseOrder) => {
  if (!order.createdAt) return null;

  const expectedToFulfillBy = order.expectedFulfillmentDate ?? order.createdAt;
  const expectedDate = parseISO(expectedToFulfillBy);

  // Order not yet past expected fulfillment date → age = 0
  if (new Date() <= expectedDate) {
    return {
      minutes: 0,
      maxDate: null,
      isFulfillmentDatePassed: false,
    };
  }

  const labelCreatedDates = order.lineItems.map(({ labelCreatedDate }) => (labelCreatedDate ? parseISO(labelCreatedDate) : new Date()));

  const maxDate = max(labelCreatedDates);
  const minutes = differenceInMinutes(expectedDate, maxDate);

  return {
    minutes,
    maxDate,
    isFulfillmentDatePassed: true,
  };
};
